import React from "react"
import styled from "styled-components"
import { ThemeProvider } from "styled-components"
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles"
import { convertMUI } from "utils/utils"
import theme from "styles/theme-main"
import Icon from "components/Icon"
import Button from "components/Button"
import SwitchField from "components/SwitchField"
import Translate from "components/Translate/container"

const ModalMask = styled.div`
  position: fixed;
  z-index: 9991;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  -webkit-backdrop-filter: blur(30px);
  backdrop-filter: blur(30px);
  transition: opacity 0.3s ease;
  background-color: rgba(255, 255, 255, 0.95);
  overflow: hidden;
`

const ModalWrapper = styled.div`
  vertical-align: middle;
  opacity: 1;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9991;
  overflow-y: scroll;
`

const CloseIconWrapper = styled.div`
  color: ${theme.colors.textPrimary};
  cursor: pointer;
  position: absolute;
  right: 124px;
  top: 84px;
  z-index: 9995;
  height: 24px;
  width: 24px;
`

const ModalContainer = styled.div`
  width: 100%;
  margin: 0px auto;
  padding: 0;
  background-color: transparent;
  transition: all 0.3s ease;
  opacity: 1;
  padding: 0 15.6% !important;
`

const Title = styled.h2`
  font-size: 56px;
  font-weight: 700;
  line-height: 1.29;
  letter-spacing: 0.8px;
  margin: 88px 0 24px;
  color: ${theme.colors.textPrimary};
`

const P = styled.p`
  color: ${theme.colors.textPrimary};
  font-size: 21px;
  line-height: 1.52;
  letter-spacing: 0.4px;
  margin-bottom: 12px;

  a {
    color: ${theme.colors.vantageHighlight};
  }

  a:hover {
    text-decoration: none;
  }
`

const H3 = styled.h3`
  color: ${theme.colors.textPrimary};
  font-size: 21px;
  line-height: 1.52;
  letter-spacing: 0.4px;
  margin-bottom: 12px;
  font-weight: 700;
`

const SwitchFieldWrapper = styled.div`
  margin-top: 30px;
`

const CookieSection = styled.div`
  margin-bottom: 50px;
`

export class CookieBanner extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      acceptAnalyticsCookies: false,
    }
  }

  handleAnalyticsSwitchChange = (name, value) => {
    this.setState({ acceptAnalyticsCookies: value })
  }

  render() {
    const { display, closeManageCookies, saveCookiePreferences } = this.props
    const { acceptAnalyticsCookies } = this.state

    const muitheme = createTheme(convertMUI(theme))

    return display ? (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider theme={muitheme}>
          <ModalMask />
          <ModalWrapper>
            <CloseIconWrapper onClick={closeManageCookies}>
              <Icon variant={"cross_sml_slate"} />
            </CloseIconWrapper>
            <ModalContainer>
              <Title>
                <Translate>Manage Cookies</Translate>
              </Title>
              <hr style={{ margin: "30px auto 30px 0" }} />
              <CookieSection>
                <P>
                  <Translate>For more information please see our</Translate>{" "}
                  <a
                    href="https://www.raretechnology.com/cookie-policy"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    <Translate>Cookie Policy</Translate>
                  </a>
                  .
                </P>
              </CookieSection>

              <CookieSection>
                <H3>
                  <Translate>Strictly necessary cookies</Translate>
                </H3>
                <P>
                  <Translate>
                    These are cookies that are required for the operation of our
                    website. They include, for example, cookies used for
                    authentication, security and to optimize our website to your
                    device settings device settings.
                  </Translate>
                </P>
              </CookieSection>

              <CookieSection>
                <H3>
                  <Translate>Analytics cookies</Translate>
                </H3>
                <P>
                  <Translate>
                    These cookies allow us to gather analytics to improve the
                    performance and functionality of our Websites.
                  </Translate>
                </P>
                <P>
                  <Translate>
                    These analytics can include measurements on the number of
                    users on our Websites, how long they stay on our Websites
                    for, and what parts of our Websites they visit. We use this
                    information in aggregate form to help us to improve the way
                    our Websites work.
                  </Translate>
                </P>
                <SwitchFieldWrapper>
                  <SwitchField
                    id={"analyticsSwitch"}
                    value={acceptAnalyticsCookies}
                    onChange={this.handleAnalyticsSwitchChange}
                    callback={console.log(this)}
                  />
                </SwitchFieldWrapper>
              </CookieSection>

              <CookieSection>
                <Button
                  onClick={() => {
                    saveCookiePreferences(acceptAnalyticsCookies)
                  }}
                  label={"Save preferences and close"}
                />
              </CookieSection>
            </ModalContainer>
          </ModalWrapper>
        </MuiThemeProvider>
      </ThemeProvider>
    ) : null
  }
}

export default CookieBanner
